var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",attrs:{"id":"wrapper"}},[_c('error-banner',{attrs:{"has-sidebar":_vm.hasSidebar}}),_vm._v(" "),_c('session-banner',{attrs:{"has-sidebar":_vm.hasSidebar}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }